<template>
    <div class="erm_wrapper">

        <AppModal :title="'Add New Category'" :width="700" :showFooter="false" ref="add_category_modal">
            <template #body>
                <AddCategory @updateDataAfterNewAdd="updateDataAfterNewAdd" />
            </template>
        </AppModal>

        <AppTable :tableData="categories" v-loading="loading">
            <template #header>
                <h1 class="table-title">All Category</h1>
                <el-button @click="openCategoryAddModal()" size="large" type="primary" icon="Plus" class="ltm_button">
                    Add New Category
                </el-button>
            </template>

            <template #filter>
                <el-input class="easyRestaurantManager-search-input erm_input" v-model="search" style="width: 240px" size="large"
                    placeholder="Please Input" prefix-icon="Search" />
            </template>

            <template #columns>
                <el-table-column prop="id" label="ID" width="80" />
                <el-table-column label="Image" width="auto">
                    <template #default="{ row }">
                        <img v-if="row?.image" :src="row?.image" alt="image"
                            style="width: 60px; height: 60px; object-fit: cover;">
                        <span v-else>No Image</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="branch_id" label="Branch Id" width="auto" /> -->
                <el-table-column prop="name" label="Name" width="auto" />
                <el-table-column prop="description" label="Description" width="auto" />
                <el-table-column label="Operations" width="120">
                    <template #default="{ row }">
                        <el-tooltip class="box-item" effect="dark" content="Click to edit categories"
                            placement="top-start">
                            <el-button @click="openUpdateCategoryModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-edit" />
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" content="Click to delete categories"
                            placement="top-start">
                            <el-button @click="openDeleteCategoryModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-delete" />
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </template>

            <template #footer>
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 40]" large :disabled="total_category <= pageSize" background
                    layout="total, sizes, prev, pager, next" :total="+total_category" />
            </template>

        </AppTable>

        <AppModal :title="'Update Category'" :width="800" :showFooter="false" ref="update_category_modal">
            <template #body>
                <AddCategory :categories_data="category" />
            </template>
        </AppModal>

        <AppModal :title="'Delete Category'" :width="500" :showFooter="false" ref="delete_category_modal">
            <template #body>

                <div class="delete-modal-body">
                    <h1>Are you sure ?</h1>
                    <p>You want to delete this category</p>
                </div>
            </template>
            <template #footer>
                <div class="easyRestaurantManager-modal-footer">
                    <el-button @click="$refs.delete_category_modal.handleClose()" type="default"
                        size="medium">Cancel</el-button>
                    <el-button @click="deleteCategory" type="primary" size="medium">Delete</el-button>
                </div>
            </template>
        </AppModal>

    </div>
</template>




<script>
import axios from 'axios';

import AppTable from "../../components/AppTable.vue";
import Icon from "../../components/Icons/AppIcon.vue";
import AppModal from "../../components/AppModal.vue";
import AddCategory from "./AddCategory.vue";
export default {
    components: {
        AppTable,
        Icon,
        AppModal,
        AddCategory
    },
    data() {
        return {
            search: '',
            categories: [],
            category: {},
            total_category: 0,
            loading: false,
            currentPage: 1,
            pageSize: 10,
            active_id: null,
            add_category_modal: false,
            rest_api: window.RestaurantMenuMangeData.rest_api,
            nonce: window.RestaurantMenuMangeData.nonce
        }

    },

    methods: {
        openCategoryAddModal() {
            this.$refs.add_category_modal.openModel();
        },

        async getCategory() {
            this.loading = true;
            try {
                const response = await axios.get(`${this.rest_api}/getCategory`, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    }
                });
                this.categories = response.data?.category_data;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching couriers:',);
            }
        },

        openDeleteCategoryModal(row) {
            this.active_id = row.id;
            this.$refs.delete_category_modal.openModel();
        },
        async deleteCategory() {
            try {
                const response = await axios.post(`${this.rest_api}/deleteCategory`, { id: this.active_id });
                this.getCategory();
                this.$refs.delete_category_modal.handleClose();
            } catch (error) {
                console.error('Error fetching couriers:',);
            }
        },
        openUpdateCategoryModal(row) {
            this.category = row;
            this.$refs.update_category_modal.openModel();
        },

        updateDataAfterNewAdd(new_category) {
            this.$refs.add_category_modal.handleClose();
            this.categories.unshift(new_category);
        },

    },

    mounted() {
        this.getCategory();
    }

}
</script>